import { render, staticRenderFns } from "./OdinRequest.vue?vue&type=template&id=01cba6c9"
import script from "./OdinRequest.vue?vue&type=script&lang=js"
export * from "./OdinRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports